import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-practice-delete',
  templateUrl: './practice-delete.component.html',
  styleUrls: ['./practice-delete.component.scss']
})
export class PracticeDeleteComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
